// imports are hoisted above code in the same file, so we have to record the
// start and end times via imports
import './metrics/record-components-start';

// Bring in the CSS for the Colombia responsive grid among other styles
import './styles/coreTokens.scss';
import './styles/utilityStyles.scss';

import { fireReadyEvent } from './shared/base';

export * from './components/accordion';
export * from './components/action-bar';
export * from './components/alert';
export * from './components/app-layout';
export * from './components/badge';
export * from './components/blueprint-manage-entity-list';
export * from './components/blueprint-workflow';
export * from './components/box';
export * from './components/breadcrumb';
export * from './components/button';
export * from './components/button-group';
export * from './components/calendar';
export * from './components/card';
export * from './components/carousel';
export * from './components/changeover-anchor';
export * from './components/checkbox';
export * from './components/currency-selector';
// Please note data-grid is conditionally excluded using
// the NormalModuleReplacementPlugin in webpack.components.config.js
export * from './components/data-grid';
export * from './components/data-table';
export * from './components/date-picker';
export * from './components/date-range-picker';
export * from './components/divider';
export * from './components/dropdown';
export * from './components/dropdown-button';
export * from './components/expander';
export * from './components/file-upload';
export * from './components/filter-bar';
export * from './components/flag';
export * from './components/flashbar';
export * from './components/grid';
export * from './components/hmd';
export * from './components/icon';
export * from './components/input';
export * from './components/input-group';
export * from './components/kpi-bar';
export * from './components/label';
export * from './components/layout';
export * from './components/link';
export * from './components/list';
export * from './components/modal';
export * from './components/navigation';
export * from './components/page-header';
export * from './components/pagination';
export * from './components/panel-wrapper';
export * from './components/popover';
export * from './components/predictive-input';
export * from './components/progress';
export * from './components/progressbar';
export * from './components/radiobutton';
export * from './components/radiobutton-group';
export * from './components/region-selector';
export * from './components/selection-card';
export * from './components/selection-card-group';
export * from './components/selection-list';
export * from './components/spinner';
export * from './components/star-rating';
export * from './components/statusindicator';
export * from './components/statustracker';
export * from './components/summary';
export * from './components/table';
export * from './components/tabs';
export * from './components/tag';
export * from './components/textarea';
export * from './components/thumbnail';
export * from './components/tile';
export * from './components/tile-grid';
export * from './components/toast-group';
export * from './components/toggle';
export * from './components/tooltip';
export * from './components/workflowtracker';

import './metrics/record-components-end';

fireReadyEvent('katal', 'katal-ready');
